import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import MainLayout from './layouts/MainLayout';
import Home from './pages/Home';
import Tools from './pages/Tools';
import About from './pages/About';
import GoogleAnalytics from './components/GoogleAnalytics';
import WelcomeModal from './components/WelcomeModal';
import './styles/global.css';

function App() {
  return (
    <>
      <GoogleAnalytics measurementId="G-R3TSZ19G2E" />
      <WelcomeModal />
      <Router>
        <Routes>
          <Route path="/" element={<MainLayout />}>
            <Route index element={<Home />} />
            <Route path="tools" element={<Tools />} />
            <Route path="about" element={<About />} />
          </Route>
        </Routes>
      </Router>
    </>
  );
}

export default App; 